import type { FC } from 'react'
import { memo } from 'react'

import { Tooltip, TooltipContent, TooltipTrigger } from '@fp/ui-kit'
import { cn } from '@lib/cn'
import { formatDate, type DateFormat } from '@lib/formatters'

type DateValue = string | null | undefined

export const ShowDataAndTooltip: FC<{ data: DateValue | DateValue[]; format?: DateFormat; labels?: string[] }> = memo(
  ({ data, format, labels }) => {
    const values = Array.isArray(data) ? data : [data]

    if (!values.some(Boolean)) return '—'

    const [firstValue] = values
    const stackedValue = !format && values.length === 1 ? firstValue : undefined

    return (
      <Tooltip delayDuration={0}>
        <TooltipTrigger className={cn(stackedValue && 'flex flex-col leading-4')}>
          {stackedValue ? (
            <>
              {formatDate(stackedValue, 'short')}
              <span className='text-xs text-muted-foreground'>{formatDate(stackedValue, 'timeShort')}</span>
            </>
          ) : (
            values.map((d) => (d ? formatDate(d, format ?? 'short') : '—')).join(' / ')
          )}
        </TooltipTrigger>
        <TooltipContent>
          {values.map((d, i) => (
            <p key={`${i}-${d ?? 'none'}`}>
              {labels?.[i] ? `${labels[i]}: ` : ''}
              {d ? formatDate(d, 'fullWithZone') : '—'}
            </p>
          ))}
        </TooltipContent>
      </Tooltip>
    )
  },
)

ShowDataAndTooltip.displayName = 'ShowDataAndTooltip'
